export type PlanningItem = server.dto.ShowForPlanningMap | server.dto.VenueForPlanningMap | server.dto.AirportForPlanningMap;

export const isShowItem = (item: PlanningItem): item is server.dto.ShowForPlanningMap => {
  return (item as server.dto.ShowForPlanningMap).showId !== undefined;
}

export const isVenueItem = (item: PlanningItem): item is server.dto.VenueForPlanningMap => {
  return (item as server.dto.VenueForPlanningMap).venueId !== undefined;
}

export const isAirportItem = (item: PlanningItem): item is server.dto.AirportForPlanningMap => {
  return (item as server.dto.AirportForPlanningMap).airportId !== undefined;
}

export const allFilterLayers = ["show", "venue", "airport"] as const;
export type FilterLayerType = typeof allFilterLayers[number];

export const showListUniqueKey = "planningMap_showList";

export const getListUniqueKey = (layer: FilterLayerType) => `planningMap_${layer}List`;

export const groupPlanningItemsByLocation = (items: PlanningItem[]): Record<string, Array<PlanningItem>> => {
  return items.reduce((acc, item) => {
    const key = `${item.point.lat},${item.point.lng}`;
    acc[key] = (acc[key] || []).concat(item);
    return acc;
  }, {});
}

export const sortPlanningItemWithFilteredInFront = <T extends PlanningItem>(items: T[], selectedPoint: server.dto.Geo): T[] => {
  return [...items].sort((a, b) => {
    const isSelectedA = planningItemIsOnLocation(a, selectedPoint);
    const isSelectedB = planningItemIsOnLocation(b, selectedPoint);

    if (isSelectedA && !isSelectedB) {
      return -1;
    }

    if (!isSelectedA && isSelectedB) {
      return 1;
    }

    return 0;
  });
}

export const planningItemIsOnLocation = (item: PlanningItem, location: server.dto.Geo): boolean => {
  return item.point.lat === location.lat && item.point.lng === location.lng;
}